<template>
  <div id="culture">
    <div class="culture-content">
      <div class="culture-banner">
        <img src="../../../static/images/culture-banner.jpg" alt="">
      </div>

      <div class="culture-main">

        <div class="culture-main-itembox1 clearfix">
          <div class="culture-main-item">
            <div class="cimg-box"><img src="../../../static/images/culture-icon1.png"></div>
            <h3>真诚</h3>
            <p>以诚学习则无事不克</p>
            <p>以诚立业则无业不兴</p>
          </div>
          <div class="culture-main-item">
            <div class="cimg-box"><img src="../../../static/images/culture-icon2.png"></div>
            <h3>效率</h3>
            <p>先进可靠专业及时</p>
            <p>简单便捷专注需求</p>
          </div>
          <div class="culture-main-item">
            <div class="cimg-box"><img src="../../../static/images/culture-icon3.png"></div>
            <h3>专业</h3>
            <p>关注用户需求</p>
            <p>软件以人为本</p>
          </div>
        </div>

        <div class="culture-main-itembox2 clearfix">

          <div class="culture-main-item2 clearfix">
            <div class="circle1"><div class="circle2"></div></div>
            <p>年度竞聘制 - 所有岗位全员竞聘，能者上，庸者下。</p>
          </div>

          <div class="culture-main-item2 clearfix">
            <div class="circle1"><div class="circle2"></div></div>
            <p>创业者平台 - 每位员工都是创业者，可以发起任何一个项目。</p>
          </div>

          <div class="culture-main-item2 clearfix">
            <div class="circle1"><div class="circle2"></div></div>
            <p>扁平化管理 - 公开公正公平，高效管理与决策。</p>
          </div>

          <div class="culture-main-item2 clearfix">
            <div class="circle1"><div class="circle2"></div></div>
            <p>互联网公司 - 年度旅游、生日party、下午茶。</p>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'Culture',
  data() {
    return {
      
    }
  },
  created () {
    /*this.getConpy();*/
  },
  methods: {
    
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .culture-banner
    img
      width 100%

  .culture-main
    width 1080px
    margin 0 auto

    .culture-main-itembox1
      margin 32px 0
      .culture-main-item
        text-align center
        width 315px
        height 428px
        box-sizing border-box
        -moz-box-sizing border-box
        -webkit-box-sizing border-box
        border 1px solid #000000
        float left
        margin-left 67px
        .cimg-box
          width 162px
          height 162px
          box-sizing border-box
          -moz-box-sizing border-box
          -webkit-box-sizing border-box
          border 1px solid #000000
          border-radius 50%
          line-height 162px
          margin 35px auto 18px auto

          img
            vertical-align middle

        h3
          font-size 30px
          color #000000
          margin 0 0 40px 0

        p
          font-size 24px 
          color #020202
          font-family "仿宋"
          line-height 40px
            
      .culture-main-item:nth-child(1)
        margin-left 0

    .culture-main-itembox2
      margin 0 0 50px 0
      .culture-main-item2
        width 50%
        float left
        box-sizing border-box
        -moz-box-sizing border-box
        -webkit-box-sizing border-box
        padding 0 0 0 42px
        margin 20px 0

        .circle1
          width 24px
          height 24px
          border-radius 50%
          border 1px solid #123e97
          float left

          .circle2
            width 18px 
            height 18px
            background #123e97
            border-radius 50%
            margin 3px

        p
          float left
          font-size 16px
          color #000000
          line-height 26px
          margin-left 10px

    
</style>



// WEBPACK FOOTER //
// src/components/about/culture.vue